/**
 * Created by cl-macmini-34 on 17/07/17.
 */

App.factory('offsetDST', OffsetDST);
function OffsetDST() {
    var serviceObj = {};
    serviceObj.offset = Offset;
    function Offset() {
        var today = new Date();
        var offset;
        if (today.dst())
            offset = -today.stdTimezoneOffset() - (today.getTimezoneOffset() - today.stdTimezoneOffset());
        else
            offset = -today.getTimezoneOffset();

        return offset;
    }
    Date.prototype.stdTimezoneOffset = function () {
        var jan = new Date(this.getFullYear(), 0, 1);
        var jul = new Date(this.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    };
    Date.prototype.dst = function () {
        return this.getTimezoneOffset() < this.stdTimezoneOffset();
    };
    return serviceObj;
}